import LoadingSpinner from "../UI/LoadingSpinner";

const LoadingTestPage = () => {
    return <LoadingSpinner/>;
};

export default LoadingTestPage;